import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {BroadcastMessages} from './broadcast-messages';
import {BroadcastMessagesService} from 'src/app/services/broadcast-messages/broadcast-messages.service';

@Component({
    selector: 'app-broadcast-messages',
    templateUrl: './broadcast-messages.component.html',
    styleUrls: ['./broadcast-messages.component.css'],
    standalone: false
})
export class BroadcastMessagesComponent implements OnInit {
  broadcastMessagesForm: UntypedFormGroup;
  errorMessage: any;
  messageBeginMinDate: Date;
  messageEndMinDate: Date;
  isError: boolean;
  message: BroadcastMessages;
  messageList: BroadcastMessages[];
  itemsPerPage = 10;
  updateOrDelete: boolean;

  messageColumnDefs = [
    {
      headerName: 'Scope',
      field: 'businessType',
      width: 150,
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.businessType + '</a>',
      onCellClicked: event => this.onMessageSelected(event.data)
    },
    {
      headerName: 'Begin Date',
      field: 'messageStartDate',
      width: 150,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'End Date',
      field: 'messageEndDate',
      width: 150,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      }
    },
    {
      headerName: 'Text',
      field: 'messageText',
      width: 1170
    }
  ];
  domLayout;

  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private messageServie: BroadcastMessagesService
  ) {
  }

  ngOnInit(): void {
    this.domLayout = 'autoHeight';
    this.getData();
    this.initValues();
    this.createForm();
    this.resetForm();

  }

  initValues() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.messageBeginMinDate = today;
    this.messageEndMinDate = today;
  }

  createForm() {
    this.broadcastMessagesForm = this.fb.group({
      broadcastMessageId: new UntypedFormControl('', [Validators.required]),
      businessType: new UntypedFormControl('', [Validators.required]),
      messageBeginDate: new UntypedFormControl('', [Validators.required]),
      messageEndDate: new UntypedFormControl('', [Validators.required]),
      messageText: new UntypedFormControl('', [Validators.required])
    });
  }

  resetForm() {
    this.broadcastMessagesForm.controls['broadcastMessageId'].setValue(0);
    this.broadcastMessagesForm.controls['businessType'].setValue('');
    this.broadcastMessagesForm.controls['messageBeginDate'].setValue(new Date());
    this.broadcastMessagesForm.controls['messageEndDate'].setValue('');
    this.broadcastMessagesForm.controls['messageText'].setValue('');
  }

  getData() {
    this.messageServie.getMessages().subscribe(data => {
      this.messageList = data;
      this.updateOrDelete = false;
      this.resetForm();
    });


  }

  messageBeginDateChange(event) {
    this.messageEndMinDate = this.broadcastMessagesForm.controls['messageBeginDate'].value;
  }

  messageEndDateChange(event) {

  }

  onMessageText(event) {

  }

  createMessages() {
    this.message = new BroadcastMessages();
    this.message.broadcastMessageId = 0;
    this.message.businessType = this.broadcastMessagesForm.controls['businessType'].value;
    this.message.messageStartDate = this.broadcastMessagesForm.controls['messageBeginDate'].value;
    this.message.messageEndDate = this.broadcastMessagesForm.controls['messageEndDate'].value;
    this.message.messageText = this.broadcastMessagesForm.controls['messageText'].value;
    this.tmssLoader.show();
    this.messageServie.createMessage(this.message).subscribe(
      data => {
        this.alertService.success(' The message has been created successfully.');
        this.getData();
        this.tmssLoader.hide();
      }, error => {
        this.alertService.error('There was an error while creating the message.');
        this.tmssLoader.hide();
      }
    );
  }

  updateMessages() {
    this.message = new BroadcastMessages();
    this.message.broadcastMessageId = this.broadcastMessagesForm.controls['broadcastMessageId'].value;
    this.message.businessType = this.broadcastMessagesForm.controls['businessType'].value;
    this.message.messageStartDate = this.broadcastMessagesForm.controls['messageBeginDate'].value;
    this.message.messageEndDate = this.broadcastMessagesForm.controls['messageEndDate'].value;
    this.message.messageText = this.broadcastMessagesForm.controls['messageText'].value;
    this.messageServie.updateMessage(this.message).subscribe(
      data => {
        this.alertService.success(' The message has been updated successfully.');
        this.getData();
        this.tmssLoader.hide();
      }, error => {
        this.alertService.error('There was an error while updating the message.');
        this.tmssLoader.hide();
      }
    );

  }

  deleteMessages() {
    this.message = new BroadcastMessages();
    this.message.broadcastMessageId = this.broadcastMessagesForm.controls['broadcastMessageId'].value;
    this.message.businessType = this.broadcastMessagesForm.controls['businessType'].value;
    this.message.messageStartDate = this.broadcastMessagesForm.controls['messageBeginDate'].value;
    this.message.messageEndDate = this.broadcastMessagesForm.controls['messageEndDate'].value;
    this.message.messageText = this.broadcastMessagesForm.controls['messageText'].value;
    this.messageServie.deleteMessage(this.message).subscribe(
      data => {
        this.alertService.success(' The message has been deleted successfully.');
        this.getData();
        this.tmssLoader.hide();
      }, error => {
        this.alertService.error('There was an error while deleting the message.');
        this.tmssLoader.hide();
      }
    );
  }

  clearPage() {
    this.resetForm();
    this.updateOrDelete = false;
  }

  onMessageSelected(message: any) {
    this.updateOrDelete = true;
    this.broadcastMessagesForm.controls['broadcastMessageId'].setValue(message.broadcastMessageId);
    this.broadcastMessagesForm.controls['businessType'].setValue(message.businessType);
    this.broadcastMessagesForm.controls['messageBeginDate'].setValue(new Date(message.messageStartDate));
    this.broadcastMessagesForm.controls['messageEndDate'].setValue(new Date(message.messageEndDate));
    this.broadcastMessagesForm.controls['messageText'].setValue(message.messageText);
  }

}
